export default __webpack_public_path__ + "static/media/white-logo.ec110408.png";